import requets from '@/utils/axios';

// 密码登录
function pwdLogin(params) {
    return requets({
        url: '/login',
        method: 'post',
        data: params
    })
}

// 验证码登录
function codeLogin(params) {
    return requets({
        url: '/login_by_phone',
        method: 'post',
        data: params
    })
}

// 注册
function userRegister(params) {
    return requets({
        url: "/register",
        method: 'post',
        data: params
    })
}

// 获取验证码

function getCaptcha(params) {
    return requets({
        url: "/send_msg",
        method: "post",
        data: params,
    })
}

// 修改密码
function resetPwd(params) {
    return requets({
        url: '/change_pwd',
        method: 'post',
        data: params
    })
}

// 获取信息

function getInfo(params) {
    return requets({
        url: '/operate',
        method: 'post',
        data: {
            action: 'get',
            ...params
        }
    })
}

// 删除信息

function delInfo(params) {
    return requets({
        url: '/operate',
        method: 'post',
        data: {
            action: 'del',
            ...params
        }
    })
}

// 编辑信息

function editInfo(params) {
    return requets({
        url: '/operate',
        method: 'post',
        data: {
            action: 'edit',
            ...params
        }
    })
}

// 添加信息

function addInfo(params) {
    return requets({
        url: '/operate',
        method: 'post',
        data: {
            action: 'add',
            ...params
        }
    })
}

export {
    pwdLogin,
    codeLogin,
    userRegister,
    getCaptcha,
    resetPwd,
    getInfo,
    delInfo,
    editInfo,
    addInfo,
}